import { RefObject } from 'react';

const focusOnElement = (ref: RefObject<HTMLElement>): void => {
  setTimeout(() => {
    ref.current?.focus();
  }, 0);
};

export default focusOnElement;
